import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "inline-message";
var selectors = {
    ROOT: '.tyl-inline-message'
};
export var INLINE_MESSAGE_CONSTANTS = {
    elementName: elementName,
    selectors: selectors
};
